import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiFieldSearch, EuiInputPopover, EuiSelectable, EuiText, htmlIdGenerator } from '@elastic/eui'
import { EuiSelectableOption } from '@elastic/eui/src/components/selectable/selectable_option'

import { clearDmas, filterDmas } from 'app/dictionarySlice'
import { RootState } from 'app/rootReducer'

import useDebounce from '../../utils/useDebounce'

interface DmaTargeterProps {
  isInvalid: boolean

  addDma(dma: string): void
}

export const DmaFinder = ({ addDma, isInvalid }: DmaTargeterProps) => {
  const dispatch = useDispatch()
  const dictionary = useSelector((state: RootState) => state.dictionary)
  const [dmaSearchTerm, setDmaSearchTerm] = useState<string>('')
  const debouncedDmaSearchTerm = useDebounce(dmaSearchTerm, 100)
  const [searchDmaPopoverOpen, setSearchDmaPopoverOpen] = useState<boolean>(false)
  const [dmas, setDmas] = useState<Array<EuiSelectableOption>>([])

  const onSearchDma = () => {
    setSearchDmaPopoverOpen(false)
  }

  const onSearchDmaChange = (hint: string) => {
    setDmaSearchTerm(hint)
  }

  useEffect(() => {
    if (debouncedDmaSearchTerm) {
      dispatch(filterDmas(debouncedDmaSearchTerm))
    } else {
      dispatch(clearDmas())
    }
  }, [debouncedDmaSearchTerm, dispatch])

  useEffect(() => {
    if (dictionary.dmasFiltered) {
      let twoObjectArray = dictionary.dmasFiltered
      let oneObjectArray = []
      oneObjectArray.push(twoObjectArray[0])
      setDmas(
        oneObjectArray.map(
          dma =>
            ({
              label: dma?.name,
              key: dma?.name,
              checked: undefined,
              onClick: () => {
                addDma(dma.name)
                setSearchDmaPopoverOpen(false)
                setDmaSearchTerm('')
              }
            } as EuiSelectableOption)
        )
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dictionary.dmasFiltered])

  return (
    <EuiInputPopover
      fullWidth
      input={
        <EuiFieldSearch
          id={htmlIdGenerator()()}
          autoComplete='off'
          fullWidth
          value={dmaSearchTerm}
          isLoading={dictionary.isLoadingDmas}
          onChange={v => onSearchDmaChange(v.target.value)}
          onFocus={() => setSearchDmaPopoverOpen(true)}
          incremental={false}
          onSearch={() => onSearchDma()}
          placeholder='Type to begin search...'
          onKeyPress={e => {
            e.key === 'Enter' && e.preventDefault()
          }}
          isInvalid={isInvalid}
        />
      }
      isOpen={searchDmaPopoverOpen}
      closePopover={() => setSearchDmaPopoverOpen(false)}>
      {dictionary.dmasFiltered && dictionary.dmasFiltered.length ? (
        <EuiSelectable singleSelection options={dmas}>
          {list => list}
        </EuiSelectable>
      ) : (
        <EuiText color='subdued' size='xs'>
          <p>Start typing a search... results will appear here</p>
        </EuiText>
      )}
    </EuiInputPopover>
  )
}
